import DataTable from '@containers/DataTable';
import { useDataTable, useGlobalTable } from '@hooks';
import React, { memo, useMemo, useCallback } from 'react';
import { Bar } from 'react-chartjs-2';
import trans from 'translation';
import { KContainer, KGrid, KInput, KButton } from 'uikit';

const Client = () => {
  const data = useMemo(() => {
    return [
      {
        paid: 160,
        overdue: 37,
        balance_due: 64
      },
      {
        paid: 88,
        overdue: 77,
        balance_due: 32
      },
      {
        paid: 60,
        overdue: 18,
        balance_due: 78
      }
    ];
  }, []);

  const clientLabels = useMemo(
    () => data.map((_, index) => `Client ${index + 1}`),
    [data]
  );

  const chartData = useMemo(() => {
    return {
      labels: clientLabels,
      datasets: [
        {
          label: 'Paid',
          data: data.map(item => item.paid),
          backgroundColor: '#3995C5',
          barThickness: 20
        },
        {
          label: 'Overdue',
          data: data.map(item => item.overdue),
          backgroundColor: '#13A89E',
          barThickness: 20
        },
        {
          label: 'Balance Due',
          data: data.map(item => item.balance_due),
          backgroundColor: '#12A81E',
          barThickness: 20
        }
      ]
    };
  }, [data, clientLabels]);

  const options = {
    indexAxis: 'y' as const,
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom' as const,
        labels: {
          boxWidth: 12,
          padding: 20
        },
        display: true
      },
      tooltip: {
        mode: 'index' as const,
        intersect: false
      }
    },
    scales: {
      y: {
        type: 'category' as const,
        labels: clientLabels,
        ticks: {
          font: {
            size: 12
          }
        }
      }
    }
  };
  const columnsFunc = useCallback(
    () => [
      {
        label: trans('invoice_number'),
        name: 'invoiceNumber',
        width: '40'
      },
      {
        label: trans('account_receivable'),
        name: 'accountReceivable',
        width: '40'
      },
      {
        label: trans('total_amount'),
        name: 'totalAmount',
        width: '40'
      },
      {
        label: trans('due_date'),
        name: 'dueDate',
        width: '40'
      },
      {
        label: trans('email'),
        name: 'email',
        width: '40'
      }
    ],
    []
  );

  const table = useDataTable({
    name: 'hehe',
    // apiURL: ENDPOINTS.schedule(),
    columnsFunc
    // showFilter: false,
    // otherParams
  });

  useGlobalTable(table);

  return (
    <KContainer.Card
      height={500}
      marginT={0}
      dp="flex"
      header={{
        title: trans('by_client'),
        typo: 'TextMdBold'
      }}
    >
      <KGrid.Container spacing={2} alignItems="stretch">
        <KGrid.Item xs={3}>
          <KInput.Autocomplete
            label={trans('client_type')}
          ></KInput.Autocomplete>
        </KGrid.Item>
        <KGrid.Item xs={5}>
          <KInput.Autocomplete
            label={trans('filter_by_client')}
          ></KInput.Autocomplete>
        </KGrid.Item>
        <KGrid.Item xs={3}>
          <KInput.Autocomplete
            label={trans('calculated_by')}
          ></KInput.Autocomplete>
        </KGrid.Item>
        <KGrid.Item xs={1}>
          <KButton.Solid title="View" />
        </KGrid.Item>
      </KGrid.Container>
      <KGrid.Container
        spacing={2}
        alignItems="stretch"
        style={{ height: '100%' }}
      >
        <KGrid.Item xs={5}>
          <Bar data={chartData} options={options} />
        </KGrid.Item>
        <KGrid.Item xs={7}>
          <DataTable
            {...table}
            showLeftActions={false}
            showRightActions={false}
            showRefresh={false}
            showFilter={false}
          />
        </KGrid.Item>
      </KGrid.Container>
    </KContainer.Card>
  );
};

export default memo(Client);
